import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Modal, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, isResponseOk, parseDate} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import {ASSEMBLY_STATUS_COLOR} from "enqc-utilities/src/utils/Global";

export default class AssemblyHistoryModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly, show} = this.props
        this.state = {
            assemblyHistories:[],
            assembly:assembly?assembly:{},
            show:show
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly,show} = nextProps
            this.setState({assembly,show},() => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                    this.fetchAssemblyHistories()
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    fetchAssemblyHistories(){
        let {assemblyHistories, assembly} = this.state
        if(assembly.id) {
            let reference = assembly.reference
            this.get(Endpoint.API.ASSEMBLY_HISTORIES,
                {params: {"reference": reference, "ascending": false, "sortir": "ah.created"}},
                null, (res) => {
                    if (isResponseOk(res)) {
                        assemblyHistories = res.data
                        this.setState({assemblyHistories})
                    }
                }, false, false)
        }
    }


    render() {
        let {assemblyHistories,show} = this.state
        let {onSelect} = this.props
        if(!onSelect){
            onSelect = () => {}
        }
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.AssemblyHistories}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <Table responsive className="table-sm align-items-center table-flush">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">{label.Information}</th>
                                <th scope="col" className="text-center">{label.FW}/{label.Controller}</th>
                                <th scope="col" className="text-center">{label.Status}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {assemblyHistories.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td scope="row">{index+1}</td>
                                        <td>
                                            <span className="rounded text-black font-small p-0 fw-bolder">
                                                {item.user.firstname}/{item.user.manufacturingSite.name}
                                            </span>
                                            <br/>
                                            <span className="rounded text-italic font-small p-0 fs-9">
                                                {label.Date}:{parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                        <span className="text-blue fw-400 text-italic">
                                            {isEmpty(item.fwVersion)?"-":item.fwVersion}
                                        </span>
                                            <br/>
                                        <span className="fw-normal fw-bolder">
                                            {isEmpty(item.controller)?"-":item.controller}
                                        </span>
                                        </td>
                                        <td className="text-center">
                                            <Button
                                                size="sm"
                                                className="fw-normal fs-8 btn-outline-soft"
                                                disabled={true}
                                                style={{backgroundColor:ASSEMBLY_STATUS_COLOR[item.assemblyStatus.name]}}>
                                                {item.assemblyStatus?label(item.assemblyStatus.label):"-"}
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
AssemblyHistoryModal.propTypes = {
    assembly:PropTypes.object.isRequired,
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func.isRequired,
}
